import { render, staticRenderFns } from "./BotaoVisualizarPropostas.vue?vue&type=template&id=52441c40&scoped=true"
import script from "./BotaoVisualizarPropostas.vue?vue&type=script&lang=js"
export * from "./BotaoVisualizarPropostas.vue?vue&type=script&lang=js"
import style0 from "./BotaoVisualizarPropostas.vue?vue&type=style&index=0&id=52441c40&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52441c40",
  null
  
)

export default component.exports